import type { SessionSubject } from "@/types/eryndal";
import { apiGet, apiPatch } from "./client";

export interface SubjectDrop {
  drop_topic?: string;
  drop_entity?: string;
  drop_thread?: string;
}

export async function getSessionSubject(sessionId: string): Promise<SessionSubject> {
  return apiGet<SessionSubject>(
    `/chat/sessions/${encodeURIComponent(sessionId)}/subject`,
  );
}

export async function patchSessionSubject(
  sessionId: string,
  drop: SubjectDrop,
): Promise<SessionSubject> {
  return apiPatch<SessionSubject, SubjectDrop>(
    `/chat/sessions/${encodeURIComponent(sessionId)}/subject`,
    drop,
  );
}
